"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bottom_tabs_1 = require("@react-navigation/bottom-tabs");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const config_1 = require("../../../web/firebase/config");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const icons_1 = require("../../assets/icons");
const images_1 = require("../../assets/images");
const components_1 = require("../../components");
const ModalAddPost_1 = __importDefault(require("../../components/modal/ModalAddPost"));
const CustomText_1 = __importDefault(require("../../components/text/CustomText"));
const HiddenNavigator_1 = __importDefault(require("../../navigators/HiddenNavigator"));
const HomeNavigator_1 = __importDefault(require("../../navigators/HomeNavigator"));
const NotiNavigation_1 = __importDefault(require("../../navigators/NotiNavigation"));
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const SearchArticleNavigator_1 = __importDefault(require("../../navigators/SearchArticleNavigator"));
const SearchHistory_1 = __importDefault(require("../../navigators/SearchHistory"));
const scale_1 = require("../../utils/scale");
const syncStorage_1 = require("../../utils/syncStorage");
const getTabIconSource = (index, isFocused) => {
    switch (index) {
        case 0:
            return isFocused ? images_1.images.HomeFocus : images_1.images.IconHome;
        case 1:
            return isFocused ? images_1.images.SearchFocus : images_1.images.IconSearchArticle;
        case 2:
            return isFocused ? images_1.images.HistoryFocus : images_1.images.IconSearchHistory;
        case 3:
            return isFocused ? images_1.images.NotiFocus : images_1.images.IconNoti;
        default:
            return null;
    }
};
const CustomTabBar = (props) => {
    const { state, descriptors, navigation } = props;
    const tabBarStyle = descriptors[state.routes[state.index].key].options.tabBarStyle;
    return (react_1.default.createElement(react_native_1.View, { style: [styles.tabContainer, tabBarStyle] },
        react_1.default.createElement(react_native_1.View, { style: styles.tabBody }, state.routes.map((route, index) => {
            const [pressed, setPress] = (0, react_1.useState)(false);
            const { options } = descriptors[route.key];
            const isFocused = state.index === index;
            const label = options.tabBarLabel !== undefined
                ? options.tabBarLabel
                : route.name;
            const onPress = () => {
                const event = navigation.emit({
                    type: 'tabPress',
                    target: route.key,
                    canPreventDefault: true
                });
                if (isFocused) {
                    navigation.reset({
                        index: 0,
                        routes: [{ name: route.name }]
                    });
                }
                if (!isFocused && !event.defaultPrevented) {
                    // The `merge: true` option makes sure that the params inside the tab screen are preserved
                    // @ts-ignore 
                    navigation.navigate({ name: route.name, merge: true });
                }
            };
            const onLongPress = () => {
                navigation.emit({
                    type: 'tabLongPress',
                    target: route.key
                });
            };
            return (react_1.default.createElement(react_native_1.Pressable, { key: route.key, onPress: onPress, onLongPress: onLongPress, 
                // @ts-ignore
                style: ({ hovered }) => {
                    return [
                        styles.tabItem,
                        options.tabBarItemStyle,
                        hovered && { backgroundColor: '#D6F2FF' },
                        (isFocused || pressed) && { backgroundColor: '#0591E8B2' },
                    ];
                }, onPressIn: () => setPress(true), onPressOut: () => {
                    const timeout = setTimeout(() => {
                        setPress(false);
                        clearTimeout(timeout);
                    }, 100);
                }, accessibilityRole: "button", accessibilityState: isFocused ? { selected: true } : {}, accessibilityLabel: options.tabBarAccessibilityLabel },
                react_1.default.createElement(react_native_1.View, { style: { position: 'relative' } },
                    react_1.default.createElement(react_native_1.Image, { source: getTabIconSource(index, (isFocused || pressed)), style: {
                            width: (0, scale_1.scale)(28),
                            height: (0, scale_1.scale)(28),
                        } }),
                    index == 3 && (react_1.default.createElement(react_native_1.View, { style: [styles.badge, options.tabBarBadgeStyle] }))),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: [
                        styles.tabItemLabel,
                        { color: (isFocused || pressed) ? "#FEFEFE" : "#292A33" },
                    ] }, label)));
        }))));
};
const AddButton = () => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.LinearButton, { containerStyle: [styles.bottomButton, { borderRadius: 9999 }], title: '', style: {
                width: (0, scale_1.scale)(52),
                height: (0, scale_1.scale)(52),
                borderRadius: 9999,
                overflow: 'hidden'
            }, onPress: () => setVisible(true) },
            react_1.default.createElement(icons_1.IconPlus, null)),
        react_1.default.createElement(ModalAddPost_1.default, { visible: visible, onClose: () => setVisible(false) })));
};
const Tab = (0, bottom_tabs_1.createBottomTabNavigator)();
const BottomTabBar = () => {
    const [addButtonVisible, setAddButtonVisible] = (0, react_1.useState)(true);
    const [tabBarVisible, setTabBarVisible] = (0, react_1.useState)(true);
    const [notiTimestamp, setNotiTimestamp] = (0, react_1.useState)(-1);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const userAuthFirebase = (0, react_redux_1.useSelector)((state) => state.loginFirebaseReducer.user, react_redux_1.shallowEqual);
    const [showIconDoc, setShowIconDoc] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        (async () => {
            const time = await (0, syncStorage_1.asyncStorageGetItem)('TIMENOTI');
            setNotiTimestamp(parseInt(time || '0'));
        })();
    }, []);
    (0, react_1.useEffect)(() => {
        let unsubscribe;
        if (userAuthFirebase && dataUser && notiTimestamp != -1) {
            unsubscribe = config_1.firebase
                .firestore()
                .collection('users')
                .doc(dataUser?.user_id?.toString())
                .collection('boxNotifications')
                .where('updatedAt', '>', +notiTimestamp)
                .where('isRead', '==', 0)
                .onSnapshot((snapshot) => {
                if (!snapshot.empty) {
                    setShowIconDoc(true);
                }
                else {
                    setShowIconDoc(false);
                }
            });
        }
        return () => {
            unsubscribe?.();
        };
    }, [userAuthFirebase, dataUser?.user_id, notiTimestamp]);
    return (react_1.default.createElement(react_native_1.View, { style: { flex: 1, overflow: 'hidden' } },
        react_1.default.createElement(Tab.Navigator, { tabBar: (props) => react_1.default.createElement(CustomTabBar, { ...props }), initialRouteName: Routes_1.default.HOMENAVIGATOR, screenOptions: {
                headerShown: false,
                tabBarStyle: {
                    display: tabBarVisible ? 'flex' : 'none'
                },
                tabBarHideOnKeyboard: react_native_1.Platform.OS === 'android',
            }, backBehavior: "history", screenListeners: {
                state: (e) => {
                    // LISTEN FOCUS SCREEN TO HIDDEN TAB_BAR OR ADD_BUTTON
                    const routeName = (0, native_1.getFocusedRouteNameFromRoute)(e.data.state.routes[e.data.state.index]);
                    if (!!routeName) {
                        const specialScreens = [
                            Routes_1.default.CHANGE_PASSWORD,
                            Routes_1.default.MIND_MAP_SCREEN,
                            Routes_1.default.EDIT_PHONE_SCREEN,
                            Routes_1.default.VERIFY_PHONE_SCREEN,
                            Routes_1.default.DELETE_ACCOUNT_ONE_SCREEN,
                            Routes_1.default.DELETE_ACCOUNT_TWO_SCREEN,
                            Routes_1.default.DELETE_ACCOUNT_THREE_SCREEN,
                            Routes_1.default.DELETE_ACCOUNT_FOUR_SCREEN,
                            Routes_1.default.REASON_DELETE_SCREEN,
                            Routes_1.default.CONFIRM_DELETE_ACCOUNT_SCREEN,
                        ];
                        if (specialScreens?.includes(routeName)) {
                            setAddButtonVisible(false);
                            setTabBarVisible(false);
                            return;
                        }
                        else if (e.data.state.index == 3) {
                            setAddButtonVisible(false);
                        }
                        else {
                            const specialScreens = [Routes_1.default.CONFIRM_DELETE_SUCCESS_SCREEN, Routes_1.default.DETAIL_STORY,];
                            if (!!routeName && specialScreens.includes(routeName)) {
                                setAddButtonVisible(false);
                            }
                            else {
                                setAddButtonVisible(true);
                            }
                        }
                    }
                    else {
                        setAddButtonVisible(true);
                    }
                    setTabBarVisible(true);
                },
            } },
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.HOMENAVIGATOR, component: HomeNavigator_1.default, options: {
                    tabBarLabel: 'ホーム',
                    tabBarItemStyle: {
                        borderTopLeftRadius: (0, scale_1.scale)(8),
                        borderBottomLeftRadius: (0, scale_1.scale)(8),
                    }
                } }),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.SEARCH_ARTICLE_TAP, component: SearchArticleNavigator_1.default, options: {
                    tabBarLabel: '記事を探す',
                } }),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.SEARCH_HISTORY, component: SearchHistory_1.default, options: {
                    tabBarLabel: '自分史を探す',
                } }),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.NOTI, component: NotiNavigation_1.default, listeners: ({ navigation }) => ({
                    focus: () => {
                        const currentTime = new Date().getTime();
                        setNotiTimestamp(currentTime);
                        setShowIconDoc(false);
                        (0, syncStorage_1.asyncStorageSetItem)('TIMENOTI', currentTime);
                        setAddButtonVisible(false);
                    },
                    blur: () => {
                        const state = navigation.getState();
                        const currentTime = new Date().getTime();
                        (0, syncStorage_1.asyncStorageSetItem)('TIMENOTI', currentTime);
                        setNotiTimestamp(currentTime);
                        state.routes.forEach((route, tabIndex) => {
                            if (state?.index !== tabIndex && route.state?.index > 0) {
                                navigation.dispatch(native_1.StackActions.popToTop());
                            }
                        });
                    },
                }), options: {
                    tabBarLabel: '通知',
                    tabBarBadgeStyle: {
                        display: showIconDoc ? 'flex' : 'none'
                    },
                    tabBarItemStyle: {
                        borderTopRightRadius: (0, scale_1.scale)(8),
                        borderBottomRightRadius: (0, scale_1.scale)(8),
                    },
                } }),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.HIDDEN_TAB_NAVIGATOR, component: HiddenNavigator_1.default, options: {
                    tabBarItemStyle: { display: 'none' },
                    unmountOnBlur: true,
                } })),
        addButtonVisible &&
            dataUser?.registration_status != 0 &&
            (react_1.default.createElement(AddButton, null))));
};
exports.default = BottomTabBar;
var styles = react_native_1.StyleSheet.create({
    tabBar: {},
    container: {
        flex: 1,
        alignItems: 'center',
        paddingTop: (0, scale_1.scale)(3),
    },
    label: {
        fontSize: (0, scale_1.moderateScale)(10),
        marginTop: (0, scale_1.scale)(2),
        textAlign: 'center',
        width: 100,
        lineHeight: (0, scale_1.moderateScale)(15),
    },
    bottomButton: {
        position: 'absolute',
        right: (0, scale_1.scale)(16),
        bottom: (0, scale_1.scale)(68),
        alignItems: 'center',
    },
    labelBottombarActive: {
        textShadowColor: '#00000066',
        textShadowOffset: { width: 0, height: 0 },
        textShadowRadius: 5,
    },
    tabContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: (0, scale_1.scale)(8),
        backgroundColor: Colors_1.default.transparent,
    },
    tabBody: {
        width: (0, scale_1.scale)(343),
        height: (0, scale_1.scale)(52),
        borderRadius: (0, scale_1.scale)(8),
        flexDirection: 'row',
        alignSelf: 'center',
        backgroundColor: '#FEFEFEB2',
        shadowColor: '#00000014',
        shadowOpacity: 1,
        shadowRadius: 10,
        shadowOffset: {
            width: 0,
            height: (0, scale_1.scale)(4),
        },
        elevation: 2
    },
    tabItem: {
        flex: 1,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    tabItemLabel: {
        marginTop: (0, scale_1.scale)(2),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        textAlign: 'center',
    },
    badge: {
        position: 'absolute',
        top: 0,
        right: -(0, scale_1.scale)(4.5),
        height: (0, scale_1.scale)(9),
        width: (0, scale_1.scale)(9),
        borderRadius: 99,
        backgroundColor: '#D32F2F',
    }
});
